"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribeFuturesOrderHistory = exports.resetFuturesActivePage = exports.requestFuturesOpenOrders = exports.requestFuturesInactiveOrders = exports.requestFuturesFilledOrders = exports.receiveFuturesOrderUpdate = exports.receiveFuturesOpenOrders = exports.receiveFuturesInactiveOrders = exports.receiveFuturesFilledOrders = exports.getFuturesOpenOrders = exports.getFuturesInactiveOrders = exports.getFuturesFilledOrders = exports.cancelSellFuturesOrders = exports.cancelFuturesOrders = exports.cancelBuyFuturesOrders = exports.cancelAllFuturesOrders = exports.RESET_FUTURES_ACTIVE_PAGE = exports.REQUEST_FUTURES_OPEN_ORDERS = exports.REQUEST_FUTURES_INACTIVE_ORDERS = exports.REQUEST_FUTURES_FILLED_ORDERS = exports.RECEIVE_FUTURES_ORDER_UPDATE = exports.RECEIVE_FUTURES_OPEN_ORDERS = exports.RECEIVE_FUTURES_INACTIVE_ORDERS = exports.RECEIVE_FUTURES_FILLED_ORDERS = void 0;
var _apiActions = require("../../actions/apiActions");
var _snackbarActions = require("../../actions/snackbarActions");
var _selectors = require("../selectors");
var _futuresOrdersSelectors = require("../selectors/futuresOrdersSelectors");
var _FuturesOrderStateSubscriptionService = _interopRequireDefault(require("../services/FuturesOrderStateSubscriptionService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var REQUEST_FUTURES_OPEN_ORDERS = exports.REQUEST_FUTURES_OPEN_ORDERS = 'REQUEST_FUTURES_OPEN_ORDERS';
var RECEIVE_FUTURES_OPEN_ORDERS = exports.RECEIVE_FUTURES_OPEN_ORDERS = 'RECEIVE_FUTURES_OPEN_ORDERS';
var RECEIVE_FUTURES_ORDER_UPDATE = exports.RECEIVE_FUTURES_ORDER_UPDATE = 'RECEIVE_FUTURES_ORDER_UPDATE';
var REQUEST_FUTURES_INACTIVE_ORDERS = exports.REQUEST_FUTURES_INACTIVE_ORDERS = 'REQUEST_FUTURES_INACTIVE_ORDERS';
var RECEIVE_FUTURES_INACTIVE_ORDERS = exports.RECEIVE_FUTURES_INACTIVE_ORDERS = 'RECEIVE_FUTURES_INACTIVE_ORDERS';
var RESET_FUTURES_ACTIVE_PAGE = exports.RESET_FUTURES_ACTIVE_PAGE = 'RESET_FUTURES_ACTIVE_PAGE';
var REQUEST_FUTURES_FILLED_ORDERS = exports.REQUEST_FUTURES_FILLED_ORDERS = 'REQUEST_FUTURES_FILLED_ORDERS';
var RECEIVE_FUTURES_FILLED_ORDERS = exports.RECEIVE_FUTURES_FILLED_ORDERS = 'RECEIVE_FUTURES_FILLED_ORDERS';
var requestFuturesOpenOrders = exports.requestFuturesOpenOrders = function requestFuturesOpenOrders() {
  return {
    type: REQUEST_FUTURES_OPEN_ORDERS
  };
};
var receiveFuturesOpenOrders = exports.receiveFuturesOpenOrders = function receiveFuturesOpenOrders(payload) {
  return {
    type: RECEIVE_FUTURES_OPEN_ORDERS,
    payload: payload
  };
};
var getFuturesOpenOrders = exports.getFuturesOpenOrders = function getFuturesOpenOrders(AccountId, OMSId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var result, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            dispatch(requestFuturesOpenOrders());
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetOpenFuturesOrders', {
              AccountId: AccountId,
              OMSId: OMSId
            }));
          case 1:
            result = _context.v;
            if (Array.isArray(result)) {
              dispatch(receiveFuturesOpenOrders(result));
            } else {
              console.error('GetOpenFuturesOrders error: ', result);
              dispatch((0, _snackbarActions.showSnack)({
                id: 'getFuturesOpenOrdersError',
                text: result.errormsg,
                type: 'warning'
              }));
            }
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error('GetAccountFuturesOpenOrders error: ', _t);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var receiveFuturesOrderUpdate = exports.receiveFuturesOrderUpdate = function receiveFuturesOrderUpdate(payload) {
  return {
    type: RECEIVE_FUTURES_ORDER_UPDATE,
    payload: payload
  };
};
var requestFuturesInactiveOrders = exports.requestFuturesInactiveOrders = function requestFuturesInactiveOrders() {
  return {
    type: REQUEST_FUTURES_INACTIVE_ORDERS
  };
};
var receiveFuturesInactiveOrders = exports.receiveFuturesInactiveOrders = function receiveFuturesInactiveOrders(payload) {
  return {
    type: RECEIVE_FUTURES_INACTIVE_ORDERS,
    payload: payload
  };
};
var resetFuturesActivePage = exports.resetFuturesActivePage = function resetFuturesActivePage(componentId) {
  return {
    type: RESET_FUTURES_ACTIVE_PAGE,
    payload: {
      componentId: componentId
    }
  };
};
var requestFuturesFilledOrders = exports.requestFuturesFilledOrders = function requestFuturesFilledOrders() {
  return {
    type: REQUEST_FUTURES_FILLED_ORDERS
  };
};
var receiveFuturesFilledOrders = exports.receiveFuturesFilledOrders = function receiveFuturesFilledOrders(payload) {
  return {
    type: RECEIVE_FUTURES_FILLED_ORDERS,
    payload: payload
  };
};
var getFuturesInactiveOrders = exports.getFuturesInactiveOrders = function getFuturesInactiveOrders(AccountId, OMSId) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var result, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            dispatch(requestFuturesInactiveOrders());
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetFuturesOrderHistory', {
              AccountId: AccountId,
              OMSId: OMSId,
              StartIndex: page,
              Depth: 6
            }));
          case 1:
            result = _context2.v;
            if (Array.isArray(result) && result.length >= 0) {
              dispatch(receiveFuturesInactiveOrders(result));
            } else {
              console.error('GetFuturesOrderHistory error: ', result.errormsg);
              dispatch((0, _snackbarActions.showSnack)({
                id: 'getFuturesInactiveOrdersError',
                text: result.errormsg,
                type: 'warning'
              }));
            }
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            console.error('GetFuturesOrderHistory error: ', _t2);
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var subscribeFuturesOrderHistory = exports.subscribeFuturesOrderHistory = function subscribeFuturesOrderHistory() {
  return function (dispatch) {
    _FuturesOrderStateSubscriptionService["default"].subscribe(function (updates) {
      dispatch(receiveFuturesOrderUpdate(updates));

      // Display appropriate notification based on order state
      if (['Rejected', 'Canceled'].includes(updates.OrderState)) {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'FuturesOrderStateEventSnackbar',
          text: "Futures order ".concat(updates.OrderId, " ").concat(updates.OrderState.toLowerCase()),
          type: 'warning'
        }));
      } else if (updates.OrderState === 'FullyExecuted') {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'FuturesOrderStateEventSnackbar',
          text: "Futures order ".concat(updates.OrderId, " executed"),
          type: 'success'
        }));
      }
    });
  };
};
var getFuturesFilledOrders = exports.getFuturesFilledOrders = function getFuturesFilledOrders(AccountId, OMSId) {
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
  var page = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch) {
      var result, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            _context3.p = 0;
            dispatch(requestFuturesFilledOrders());
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetFuturesTradeHistory', {
              AccountId: AccountId,
              OMSId: OMSId,
              Depth: limit,
              StartIndex: page
            }));
          case 1:
            result = _context3.v;
            if (Array.isArray(result) && result.length >= 0) {
              dispatch(receiveFuturesFilledOrders(result));
            } else {
              console.error('GetFuturesTradeHistory error: ', result.errormsg);
              dispatch((0, _snackbarActions.showSnack)({
                id: 'getFuturesFilledOrdersError',
                text: result.errormsg,
                type: 'warning'
              }));
            }
            _context3.n = 3;
            break;
          case 2:
            _context3.p = 2;
            _t3 = _context3.v;
            console.error('GetFuturesTradeHistory error: ', _t3);
          case 3:
            return _context3.a(2);
        }
      }, _callee3, null, [[0, 2]]);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var cancelFuturesOrders = exports.cancelFuturesOrders = function cancelFuturesOrders(orderIds) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var OMSId, AccountId, instrumentId, ids, cancelOrderPromises, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            OMSId = getState().user.userInfo.OMSId;
            AccountId = (0, _selectors.futuresAccountIdSelector)(getState());
            instrumentId = (0, _selectors.futuresSelectedInstrumentIdSelector)(getState());
            if (AccountId) {
              _context4.n = 1;
              break;
            }
            console.error('No futures account found');
            dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelFuturesOrdersError',
              text: 'No futures account found',
              type: 'warning'
            }));
            return _context4.a(2);
          case 1:
            _context4.p = 1;
            ids = Array.isArray(orderIds) ? orderIds : [orderIds];
            cancelOrderPromises = ids.map(function (orderId) {
              return dispatch((0, _apiActions.callAPI)('CancelFuturesOrder', {
                OrderId: orderId,
                AccountId: AccountId,
                InstrumentId: instrumentId,
                OMSId: OMSId
              }));
            });
            _context4.n = 2;
            return Promise.all(cancelOrderPromises);
          case 2:
            _context4.n = 3;
            return dispatch(getFuturesOpenOrders(AccountId, OMSId));
          case 3:
            _context4.n = 4;
            return dispatch(getFuturesFilledOrders(AccountId, OMSId));
          case 4:
            dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelFuturesOrdersSuccessSnack',
              text: ids.length === 1 ? "Futures order {{n}} cancelled" : "Futures orders {{n}} cancelled",
              textVars: {
                n: ids.join(', ')
              },
              type: 'success'
            }));
            _context4.n = 6;
            break;
          case 5:
            _context4.p = 5;
            _t4 = _context4.v;
            console.error('CancelFuturesOrder error:', _t4);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'cancelFuturesOrdersError',
              text: _t4.message || 'Failed to cancel futures order(s)',
              type: 'warning'
            }));
          case 6:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 5]]);
    }));
    return function (_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var cancelAllFuturesOrders = exports.cancelAllFuturesOrders = function cancelAllFuturesOrders() {
  return function (dispatch, getState) {
    var state = getState();
    var openOrders = (0, _futuresOrdersSelectors.futuresOpenOrdersSelector)(state);
    if (openOrders.length) {
      var orderIds = openOrders.map(function (order) {
        return order.OrderId;
      });
      return dispatch(cancelFuturesOrders(orderIds));
    } else {
      console.log('No futures orders to cancel');
    }
  };
};
var cancelBuyFuturesOrders = exports.cancelBuyFuturesOrders = function cancelBuyFuturesOrders() {
  return function (dispatch, getState) {
    var state = getState();
    var buyOrders = (0, _futuresOrdersSelectors.futuresBuyOpenOrdersSelector)(state);
    if (buyOrders.length) {
      var orderIds = buyOrders.map(function (order) {
        return order.OrderId;
      });
      return dispatch(cancelFuturesOrders(orderIds));
    } else {
      console.log('No buy futures orders to cancel');
    }
  };
};
var cancelSellFuturesOrders = exports.cancelSellFuturesOrders = function cancelSellFuturesOrders() {
  return function (dispatch, getState) {
    var state = getState();
    var sellOrders = (0, _futuresOrdersSelectors.futuresSellOpenOrdersSelector)(state);
    if (sellOrders.length) {
      var orderIds = sellOrders.map(function (order) {
        return order.OrderId;
      });
      return dispatch(cancelFuturesOrders(orderIds));
    } else {
      console.log('No sell futures orders to cancel');
    }
  };
};